module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_47-97057f46aff203736372e1a602647a16.png";